import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "zakat-donation-info-style-6" }
const _hoisted_2 = { class: "step-indicator" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createCommentVNode(" Simple Step Indicator "),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: _normalizeClass(["step-item", { active: $setup.store.step === 1 }])
      }, _cache[0] || (_cache[0] = [
        _createElementVNode("div", { class: "step-number" }, "1", -1 /* HOISTED */),
        _createElementVNode("div", { class: "step-label" }, "Amount", -1 /* HOISTED */)
      ]), 2 /* CLASS */),
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "step-divider" }, null, -1 /* HOISTED */)),
      _createElementVNode("div", {
        class: _normalizeClass(["step-item", { active: $setup.store.step === 2 }])
      }, _cache[1] || (_cache[1] = [
        _createElementVNode("div", { class: "step-number" }, "2", -1 /* HOISTED */),
        _createElementVNode("div", { class: "step-label" }, "Details", -1 /* HOISTED */)
      ]), 2 /* CLASS */),
      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "step-divider" }, null, -1 /* HOISTED */)),
      _createElementVNode("div", {
        class: _normalizeClass(["step-item", { active: $setup.store.step === 3 }])
      }, _cache[2] || (_cache[2] = [
        _createElementVNode("div", { class: "step-number" }, "3", -1 /* HOISTED */),
        _createElementVNode("div", { class: "step-label" }, "Payment", -1 /* HOISTED */)
      ]), 2 /* CLASS */)
    ])
  ]))
}